import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isActiveNavItem } from '../../helpers/navigationHelpers';


const ListItem = function ListItemComponent({ url, name, tabIndex }) {
  const linkClasses = classNames({
    'nav-drawer__link': true,
    'nav-drawer__link--active': isActiveNavItem(url),
  });

  return (
    <li className="nav-drawer__link-list__item">
      <a href={url} className={linkClasses} tabIndex={tabIndex}>{name}</a>
    </li>
  );
};

ListItem.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tabIndex: PropTypes.string.isRequired,
};

export default ListItem;
